import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  user: JSON.parse(localStorage.getItem('promaxo_user') || 'null'),
  token: localStorage.getItem('promaxo_token') || null,
  setAuth: (user, token) => {
    localStorage.setItem('promaxo_user', JSON.stringify(user));
    localStorage.setItem('promaxo_token', token);
    set({ user, token });
  },
  logout: () => {
    localStorage.removeItem('promaxo_user');
    localStorage.removeItem('promaxo_token');
    set({ user: null, token: null });
  },
}));

export const useSidebarStore = create((set) => ({
  collapsed: false,
  toggleSidebar: () => set((s) => ({ collapsed: !s.collapsed })),
}));
